import { render, staticRenderFns } from "./CustomExpansionItem.vue?vue&type=template&id=c3f9ec7a&scoped=true&"
import script from "./CustomExpansionItem.vue?vue&type=script&lang=js&"
export * from "./CustomExpansionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f9ec7a",
  null
  
)

export default component.exports